import { StatusTypes } from "../../../abstract/controller/enum/dnd/StatusTypes";
import styles from "./ChoiceContainer.module.scss";
import * as nodeUtils from "../../../abstract/controller/utils/nodeUtils";
import * as uuidUtils from "../../../abstract/controller/utils/uuidUtils";

function ChoiceContainer({ node, status, children }) {
  const _uuid = nodeUtils.getUUID(node);
  const _c_uuid = uuidUtils.getContainerUuid(_uuid);

  const getClass = () => {
    const _isPositioned = status === StatusTypes.POSITIONED;

    return `${styles["container"]} ${_isPositioned ? styles["container--hidden"] : ""}`;
  };

  return (
    <div id={_c_uuid} className={getClass()}>
      {children}
    </div>
  );
}

export default ChoiceContainer;
